import { useSelector, useDispatch } from 'react-redux';
import { IAppState } from '../../lib/types';
import configureStore from '../../../js/store';
const store = configureStore();
// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch
// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch: () => AppDispatch = useDispatch
export const useAppState = (): IAppState => useSelector((state: IAppState) => state);